import { FC } from "react";
import { pluralize } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const DocumentBulkCategoryCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { selectedDocumentCount = 0, documentBulkCategoryOptions = [] } =
        options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set category for ${selectedDocumentCount} ${pluralize("document", selectedDocumentCount)}`}
            options={documentBulkCategoryOptions}
        />
    );
};
